import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import * as Icon from "react-bootstrap-icons";

import { AgGridReact } from "ag-grid-react";

import { logout } from "../../utils";
// import NumericEditor from "../../utils/NumericEditor";
import NumericEditor from "../../utils/Editors/numericEditor";
import "./manageUsers.css";
import { themeQuartzDark } from 'ag-grid-community';

 
import { faL } from "@fortawesome/free-solid-svg-icons";

function ManageUsers() {
  const [firm_users, setFirmUsers] = useState([]);
  const [dataSource, setDataSource] = useState(null);
  const [editedRows, setEditedRows] = useState([]);

  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);

  const [deleteMappings, setDeleteMappings] = useState(false);

  const [sortable, setSortable] = useState(true);
  const [filter, setFilterable] = useState(true);
  const resizable = true;

  const manageUsersGridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "78vh", width: "100%" }), []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );
  const onFirstDataRendered = useCallback((params) => {
    manageUsersGridRef.current.api.sizeColumnsToFit();
  }, []);

  const isValidEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  function formatPhoneNumber(phoneNumber) {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumber;
  }

  function phoneRenderer(params) {
    return <span>{formatPhoneNumber(params.value)}</span>;
  }

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "checkboxBtn",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      width: 50,
      hide: false,
    },
    { field: "FirmId", hide: true },
    { field: "FirmUserId", hide: true },
    {
      field: "FirstName",
      editable: true,
    },
    { field: "LastName", editable: true },
    {
      field: "PhoneNumber",
      cellRenderer: phoneRenderer,
      cellEditor: NumericEditor,
      // cellEditorParams: {
      //   maxLength: 10,
      // },
      // cellStyle: (params) => {
      //   console.log("-----", params);
      //   if (/^\d{0,10}$/.test(params.value)) {
      //     //setValue(newValue);
      //     return null;
      //   } else {
      //     return { backgroundColor: "white", borderLeft: "3px solid red" };
      //   }
      // },
      // onCellEditingStopped: (params) => {
      //   if (/^\d{10}$/.test(params.value)) {
      //     alert("true only digits");
      //   } else {
      //     const rowIndex = params.node.rowIndex;
      //     const columnId = params.column.colId;
      //     params.api.refreshCells({
      //       rowNodes: [params.node],
      //       columns: [columnId],
      //     });
      //   }
      // },
      width: 150,
      editable: true,
    },
    {
      field: "Email",
      editable: true,
    },
    // { field: "CreatedBy" },
    // { field: "CreatedDate" },
    // { field: "UpdatedBy" },
    {
      field: "Active",
      cellEditor: "agSelectCellEditor",
      editable: true,
      cellEditorParams: {
        values: ["True", "False"],
      },
    },
  ]);

  const onGridReady = (params) => {
    manageUsersGridRef.current.api = params.api;
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    manageUsersGridRef.current.api.closeToolPanel();
  };

  const simpleComp = (p) => {
    console.log("P", p);

    // if (p.data.FieldName == "PhoneNumber") {
    return (
      <input
        type="password"
        maxLength={10}
        value={p.value}
        style={{ border: "none", width: "100%" }}
      ></input>
    );
    // }

    // return <>{p.value}</>;
  };

  const onCellValueChanged = (item) => {
    // This is to keep track of edited rows
    item.node.data["changed"] = true;
  };

  const onCellEditingStopped = (event) => {
    console.log("Event AFTER editing", event);

    setFilterable(false);
    setSortable(false);

    if (event.colDef.field == "Email") {
      if (!isValidEmail(event.newValue)) {
        alert("Email Not VAlid");
        event.node.setDataValue(event.colDef.field, event.oldValue);
      }
    }

    // setEditedRows([...editedRows, event.rowIndex]);
  };

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  const getUsers = () => {
    fetch(`${process.env.REACT_APP_BASE_URI}/firm_users/`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        data = data["Data"].map((el) => {
          el.Active = el.Active == "Y" ? "True" : "False";
          return el;
        });
        setFirmUsers(data);
      });
  };

  // Get all firm jobs
  useEffect(() => {
    getUsers();
  }, []);

  const onResetFilters = () => {
    manageUsersGridRef.current.api.setFilterModel({});
  };

  // const onResetSort = () => {
  //   manageUsersGridRef.current.api.setSortModel([]);
  // };

  const getAllRows = () => {
    let rowData = [];

    // editedRows &&
    //   manageUsersGridRef &&
    //   manageUsersGridRef.current &&
    //   manageUsersGridRef.current.api.forEachNode((node) => {
    //     if (editedRows.includes(node.rowIndex)) {
    //       rowData.push(node.data);
    //     }
    //   });

    console.log("ON SAVE GRID API : ", manageUsersGridRef.current.api);

    const changedRows = [];

    manageUsersGridRef.current.api.forEachNode((node) => {
      if (node.data.changed) {
        changedRows.push(node.data);
      }
    });

    console.log("CHANGED ROWS : ", changedRows);

    const mappedRowData =
      changedRows &&
      changedRows.map((el) => {
        return {
          FirmUserId: el.FirmUserId,
          FirmId: el.FirmId,
          FirstName: el.FirstName,
          LastName: el.LastName,
          PhoneNumber: el.PhoneNumber ? el.PhoneNumber.replace(/\D/g, "") : "",
          Email: el.Email,
          Active: el.Active == "True" ? "Y" : "N",
          CreatedBy: el.CreatedBy,
          CreatedDate: el.CreatedDate,
          UpdatedBy: el.UpdatedBy,
        };
      });

    const postOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(mappedRowData),
    };

    fetch(`${process.env.REACT_APP_BASE_URI}/firm_users/`, postOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }

        if (response.ok) {
          getUsers();
          toast.success("Manage users changes Saved successfully !", {
            position: "bottom-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "toastify-color-success",
          });
        }
        return response.json();
      })
      .catch((err) => console.log("Err: ", err));

    return rowData;
  };

  const handleAddUser = () => {
    onResetFilters();
    console.log(
      manageUsersGridRef.current.api,
      manageUsersGridRef.current.api.isAnyFilterPresent()
    );
    manageUsersGridRef.current.api.applyTransaction({
      add: [{}],
      addIndex: 0,
    });

    manageUsersGridRef.current.api.forEachNode((node) => {
      node.data.index = node.rowIndex;
    });

    // editedRows.length && setEditedRows(editedRows.map((el) => el + 1));
  };

  const handleDeleteMapping = () => {
    const selectedRows = manageUsersGridRef.current.api.getSelectedRows();
    if (selectedRows && selectedRows.length) {
      console.log("DELETED ROWS : ", selectedRows);

      setDeleteMappings(true);
    } else {
      alert("No rows selected");
    }
  };

  const deleteMappingCall = () => {
    const selectedRows = manageUsersGridRef.current.api.getSelectedRows();
    selectedRows &&
      manageUsersGridRef.current.api.applyTransaction({
        remove: selectedRows,
      });

    let dataToBeDeleted = selectedRows.map((el) => {
      return {
        FirmUserId: el.FirmUserId,
      };
    });

    const deleteOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(dataToBeDeleted),
    };

    fetch(`${process.env.REACT_APP_BASE_URI}/firm_users/`, deleteOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        getUsers();
        toast.success("Users deleted successfully !", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toastify-color-success",
        });
      });

    setDeleteMappings(false);
  };

  return (
    <Container fluid>
      <Modal show={deleteMappings} size="lg">
        <Modal.Header>
          <Modal.Title>Delete </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete the selected users </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteMappings(false)}>
            Cancel
          </Button>
          <Button
            style={{ float: "right" }}
            onClick={() => deleteMappingCall()}
            className="custom-button"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Row>
      {/* <Col md={2}>
        </Col> */}
        <Col md={12} >
          <h2 className="display-6">Manage Users</h2>
          <hr />

          {firm_users && (
          <>
          <Row>
            <div style={{ marginTop: "15px" }}>
              <Button
                className="custom-button"
                style={{ float: "left", margin: "0 0 10px 10px" }}
                onClick={() => handleAddUser()}
              >
                <Icon.Plus /> Add
              </Button>
              <Button
                className="custom-button"
                style={{ float: "left", margin: "0 0 10px 10px" }}
                onClick={() => handleDeleteMapping()}
              >
                <Icon.Trash /> Delete
              </Button>
              {editedRows && (
                <Button
                  style={{ float: "right", marginBottom: "15px" }}
                  className="custom-button"
                  onClick={() => getAllRows()}
                >
                  Save
                </Button>
              )}
            </div>
            </Row>
            <Row>
            <div className="manage-user-grid" style={containerStyle}>
              {/* <button onClick={onResetFilters}>Reset Filters</button>
              <button onClick={onResetSort}>Reset Sort</button> */}
              <div className="ag-theme-balham" style={gridStyle}>
                <AgGridReact
                  ref={manageUsersGridRef}
                  rowData={firm_users}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection="multiple"
                  onGridReady={onGridReady}
                  sideBar={"columns"}
                  sortable={sortable}
                  filter={filter}
                  resizable={resizable}
                  alwaysShowHorizontalScroll={true}
                  alwaysShowVerticalScroll={true}
                  onFirstDataRendered={onFirstDataRendered}
                  onCellValueChanged={(item) => onCellValueChanged(item)}
                  onCellEditingStopped={(event) => onCellEditingStopped(event)}
                  rowHeight={40}
                  suppressRowHoverHighlight={true}
                  singleClickEdit={true}
                  // domLayout='autoHeight'
                />
              </div>
            </div>
            </Row>
          </>
        )}
        </Col>
{/* 
          <Col md={2}>
        </Col> */}
      </Row>
    </Container>
  );
}

export default ManageUsers;
